

















import Vue, { PropType } from 'vue'
import { MapMarker, MapPosition } from '@/interfaces/gmap/Map'
import { GoogleMapLoader, GoogleMapMarker } from '@/components/gmap/'

export default Vue.extend({
  props: {
    markers: Array as PropType<MapMarker[]>,
    position: Object as PropType<MapPosition>,
    zoom: Number,
    zoomControl: Boolean,
    infoWindow: Boolean,
  },
  components: {
    GoogleMapLoader,
    GoogleMapMarker,
  },
  data() {
    return {
      mapConfig: {
        center: { lat: this.position.lat, lng: this.position.lng },
        zoom: this.zoom,
        zoomControl: this.zoomControl,
        mapTypeControl: false,
        mapTypeId: 'terrain',
        scaleControl: false,
        streetViewControl: true,
        rotateControl: false,
        fullscreenControl: false,
        styles: [
          {
            featureType: 'poi',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
        ],
      },
    }
  },
})
